import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.XeroRequestCard.XeroPoDeliveryDetails', {
    title: 'Delivery details',
    fieldAddress: 'Delivery address',
    fieldAttentionTo: 'Attention',
    fieldPhone: 'Phone',
    fieldInstructions: 'Delivery Instructions',
});
